const initialState = {
    isAuthenticated: false
}
export const authReducer = (state=initialState, action) =>{
    switch(action.type){
        default:
            return state
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/auth_reducer.js